import { render } from "./ProgressNotes.vue?vue&type=template&id=0b60b7c6"
import script from "./ProgressNotes.vue?vue&type=script&lang=js"
export * from "./ProgressNotes.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__